import { render, staticRenderFns } from "./PreviewCategoryAttribute.vue?vue&type=template&id=4fec530f&scoped=true"
import script from "./PreviewCategoryAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewCategoryAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec530f",
  null
  
)

export default component.exports